import React, { useState, useEffect } from "react";
import {
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import Switch from "@material-ui/core/Switch";
import { parseDate } from "utils/Utils";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import {
  saveAadharTransaction,
} from "store/reducers/LoanApplication/LoanApplicationSlice";
import CorrespondenceAddress from "./CorrespondenceAddress";
import { saveAadharDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import OtpModal from "../OtpModal/OtpModal.js";
import { textFormat } from "utils/Utils.js";
import { Button,Grid, InputLabel, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader.js";
import CustomeTextField from "components/UpdateUi/CustomeTextField.js";
import brandTheme from "brandTheme/Theme.js";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import { saveLoanApplicantDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import Update from "@material-ui/icons/Update";
import { parseDateString } from "utils/Utils";
import { PreFixNameList } from "assets/properties/properties";
import { aadharVendor } from "assets/properties/properties";
import AadharPhotoCaptureModal from "views/admin/components/AadharPhotoCapture/AadharPhotoCaptureModal";
import { parseDob } from "utils/Utils";
import { prefixToGenderMap } from "assets/properties/properties";
import { genderToPrefixMap } from "assets/properties/properties";
import { documentNamesList } from "assets/properties/properties";
import { functionVariableNamesList } from "assets/properties/properties";
import { loanApplicationStatus } from "assets/properties/properties";
import { headerLabel } from "assets/properties/properties";
import { loanStatusNames } from "assets/properties/properties";
import { OccupationListData } from "assets/properties/properties";
import { purposeOfLoanListData } from "assets/properties/properties";
import { GenderListData } from "assets/properties/properties";
import { customerTypeData } from "assets/properties/properties";
import checkNegativeProfileApi from "./CheckNegativeProfileApi";
import ConfirmationModal from "views/components/ConfirmationModal";
import { maxAge } from "assets/properties/properties";
import { minAge } from "assets/properties/properties";
import { statusList } from "assets/properties/properties";
import { isValidValue } from "utils/Utils";
import { isValidPincode } from "assets/properties/properties";
import { isValidateOnlyAlphabets } from "utils/Utils";
import { capitalizeFirstLetter } from "utils/Utils";

const styles = () => ({
 validateButton: { position: "absolute" ,top:0,right:0,padding:'11px 15px', margin:0},
 addressContainer:{display:'flex', alignItems:'center', textAlign:'left', margin:'2% 0 0 1%',"@media (max-width:520px)":{
  flexDirection: "column",marginTop:"20px"
},},
 nextButton:{backgroundColor:brandTheme.buttonColor}
})
const ApplicantBT = ({
  setBack,
  classes,
  setNext,
  loanApplicationId,
  loanApplicationNumber,
  PanNumberObj,
  editable,
  status,
  onNewCustomer,
  documentLink,
  setDetailsss,
  mobileNum,
  PanNameObj,
  loanAccountNumber,
  panThirdPartyPanEnabled,
  aadharThirdPartyAadharEnabled,
  aadharVendorThirdParty,
  featureFlags,
  enabledFieldsForApplciantPage
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { aadharDetails, aadharTranaction } = useSelector(
    (state) => state.loanApplication
  );
  const { applicantDetails } = useSelector(
    (state) => state.loanDetail.applicantLoanDetail
  );


  const [documentNameList,setDocumentNameList]=useState([]);
  const [maritalStatusList]=useState([
    { code: "Single", name: "Single" },
    { code: "Married", name: "Married" },
  ]);
  const [maritalStatus, setMateritalStatus] = useState(
    applicantDetails?.maritalStatus ? applicantDetails?.maritalStatus : ""
  );
  const [maritalStatusState, setmaritalStatusState] = useState(false);
  const [motherName, setMotherName] = useState(
    applicantDetails?.motherName
  );
  const [motherNameErrorState, setMotherNameErrorState] = useState(false);
  const [spouseName, setSpouseName] = useState(
    applicantDetails?.spouseName
  );
  const [spouseNameState, setSpouseNameState] = useState(false);
  const [memberCount, setMemberCount] = useState(applicantDetails?.memberCount)
  const [memeberCountError, setMemberCountError] = useState(false);
  const [annualIncomeState, setAnnualIncomeState] = useState(false);
  const [annualIncome, setAnnualIncome] = useState(applicantDetails?.applicantAnnualIncome)
  const [dateOfBirth, setDateOfBirth] = useState(applicantDetails?.dob);
  const [dateOfBirthState, setDateOfBirthState] = useState("");
  const [isAadharAvailable, setIsAadharAvailable] = useState(true);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [aadharNumber, setAadharNumber] = useState(
    applicantDetails?.adhaarNumber
  );
  const outletData = featureFlags;
  const GenderList = outletData?.genderList ? JSON.parse(outletData?.genderList) : GenderListData;
  const showPreFixName = parseAndSetFlag(outletData?.showApplicantPreFixName);
  const hideDocumentNameDataFlag = outletData?.hideDocumentNameDataFlag;
  const PurposeOfLoan = outletData?.purposeOfLoanFlag ? JSON.parse(outletData?.purposeOfLoanFlag) : purposeOfLoanListData;
  const OccupationList = outletData?.occupationListFlag ? JSON.parse(outletData?.occupationListFlag) : OccupationListData;
  const validateThirdPartyAttemptsFlag = parseAndSetFlag(outletData?.validateThirdPartyAttemptsFlag);
  const enabledReKycForDocumentVerification = parseAndSetFlag(outletData?.enabledReKycForDocumentVerification);
  const maxAgeForDateOfBirth = Number(outletData?.maxAgeForDateOfBirth) || maxAge;
  const minAgeForDateOfBirth = Number(outletData?.minAgeForDateOfBirth) || minAge;
  const showCustomerType = parseAndSetFlag(outletData?.showCustomerType);
  const singlePhtotAdhaarOcr = parseAndSetFlag(outletData?.singlePhtotAdhaarOcr);
  const customerBasedDigiLocker = parseAndSetFlag(outletData?.customerBasedDigilocker);
  const enabledAddressDetailsValidate = parseAndSetFlag(outletData?.enabledAddressDetailsValidate);
  const [aadharNumberState, setAadharNumberState] = useState(false);
  const [loanStatus,setLoanStatus]=useState(false);
  const [secretToken, setSecretToken] = useState("");
  const [tsTransID, setTsTransID] = useState("");
  const [aadharVerified, setAadharVerified] = useState(false);
  const [panNumber, setPanNumber] = useState(PanNumberObj);
  const [aadhaarPollingLoading, setAadhaarPollingLoading] = useState(false);
  const [aadharApplicantName, setAadharApplicantName] = useState(
    applicantDetails?.nameOnAdhaar || PanNameObj
  );
  const [aadharApplicantNameState, setAadharApplicantNameState] = useState(false);
  const [aadharFatherName, setAadharFatherName] = useState(
    applicantDetails?.fatherName
  );
  const [aadharFatherNameState, setAadharFatherNameState] = useState(false);
  const [email, setEmail] = useState(applicantDetails?.email);
  const [emailState, setEmailState] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [documentNameState, setDocumentNameState] = useState(false);
  const [documentNumber, setDocumentNumber] = useState("");
  const [documentNumberState, setDocumentNumberState] = useState(false);
  const [houseNumber, setHouseNumber] = useState(
    applicantDetails?.addresses?.[0]?.houseNumber
  );
  const [houseNumberState, setHouseNumberState] = useState(false);
  const [street, setStreet] = useState(
    applicantDetails?.addresses?.[0]?.street
  );
  const [streetState, setStreetState] = useState(false);
  const [locality, setLocality] = useState(
    applicantDetails?.addresses?.[0]?.locality
  );
  const [localityState, setLocalityState] = useState(false);
  const [postOffice, setPostOffice] = useState(
    applicantDetails?.addresses?.[0]?.postOffice
  );
  const [postOfficeState, setPostOfficeState] = useState(false);
  const [villageTownCity, setVillageTownCity] = useState(
    applicantDetails?.addresses?.[0]?.villageTownCity
  );
  const [villageTownCityState, setVillageTownCityState] = useState(false);
  const [stateName, setStateName] = useState(""
  );
  const [stateNameState, setStateNameState] = useState(false);
  const [district, setDistrict] = useState(
    applicantDetails?.addresses?.[0]?.district
  );
  const [districtState, setDistrictState] = useState(false);
  const [pincode, setPincode] = useState(
    applicantDetails?.addresses?.[0]?.pincode
  );
  const [pincodeState, setPincodeState] = useState(false);

  const [spinner, setSpinner] = useState(true);
  const [mobileNumber, setMobileNumber] = useState(
    applicantDetails?.alternateMobileNumber
  );
  const [mobileNumberState, setMobileNumberState] = useState(false);
  const [profile, setProfile] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState("");
  const [emailVerify, setEmailVerify] = useState("");
  const [sameAddress, setSameAddress] = useState(applicantDetails?.sameAddress);
  const correspondancAddress = applicantDetails?.addresses?.[1];
  const [purposeOfLoan, setPurposeOfLoan]= useState(applicantDetails?.purposeOfLoan);
  const [occupationTypes, setoccupationTypes]= useState(applicantDetails?.occupationType);
  const [gender, setGender]= useState(applicantDetails?.gender || 'Male')
  const [houseCorrNumberState, setHouseCorrNumberState] = useState(false);
  const [applicantDetailAgainstId, setApplicantDetailAgainstId] = useState(false);
  const [streetCorrState, setStreetCorrState] = useState(false);
  const [localityCorrState, setLocalityCorrState] = useState(false);
  const [postOfficeCorrState, setPostOfficeCorrState] = useState(false);
  const [prefixName, setPreFixName] = useState("Mr")
  const [villageTownCityCorrState, setVillageTownCityCorrState] = useState(false);
  const [stateNameCorrState, setStateNameCorrState] = useState(false);
  const [districtCorrState, setDistrictCorrState] = useState(false);
  const [pincodeCorrState, setPincodeCorrState] = useState(false);
  const [customerIdWithPan,setCustomerIdWithPan]= useState("");
  const [stateList, setStateList] = useState([]);
  const [nameOnPanCard, setNameOnPanCard] = useState(PanNameObj || applicantDetails?.nameOnPanCard);
  const [gstNumberErrorMsg, setGstNumberErrorMsg] = useState("");
  const [gstNumber, setGstNumber] = useState(applicantDetails?.gstNumber);
  const [gst, setGst] = useState(applicantDetails?.gstState);
  const [documentDisbale, setDocumentDisable] = useState(false)
  const[coresHouseNumber, setCoresHouseNumber]= useState(correspondancAddress?.houseNumber)
  const[coresStreet, setCoresStreet]= useState(correspondancAddress?.street)
  const[coresLocality, setCoresLocality]= useState(correspondancAddress?.locality)
  const[coresPostOffice, setCoresPostOffice]= useState(correspondancAddress?.postOffice)
  const[coresVillage, setCoresVillage]= useState(correspondancAddress?.villageTownCity)
  const[coresDistrict, setCoresDistrict]= useState(correspondancAddress?.district)
  const [nameOnPanCardState, setNameOnPanCardState] = useState(false)
  const[coresPinCode, setCoresPinCode]= useState(correspondancAddress?.pincode);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [riskPresent,setRiskPresent] = useState(false);
  const[coresState, setCoresState]=useState(correspondancAddress?.state)
  const [digilance, setDigilance] = useState(false)
  const [digilanceData, setDigilanceData] = useState([])
  const [dueDigilance, setDueDigilance]= useState(false)
  const [digilanceState, setDigilanceState]= useState("")
  const [documentExpiryState, setDocumentExpiryState] = useState(false);
  const [documentExpiry, setDocumentExpiry]= useState(applicantDetails?.documentExpiry);
  const showEmailOnApplicantFlag = parseAndSetFlag(outletData?.showEmailOnApplicantFlag);
  const disabledApplicantLoanDetailsFlag = parseAndSetFlag(outletData?.disabledApplicantLoanDetailsFlag);
  const enableNegativeProfileCheck = parseAndSetFlag(outletData?.enableCheckNegativeProfile);
  const [disabledFields, setDisabledFields] = useState(false);
  const [modalrepOpen, setModalReOpen]=useState(false)
  const [prefixNameState, setPreFixNameState] = useState(false)
  const [panNumberDisabled, setPanNumberDisabled]=useState(false)
  const [panVerified, setPanVerified] = useState(false);
  const annualIncomeAmount = outletData?.annualIncomeFlag;
  const aadharIntegrationListFlag = JSON.parse(outletData?.aadharIntegrationListFlag || "[]");
  const [aadharIntegrationOptions, setAadharIntegrationOptions] = useState(aadharIntegrationListFlag);
  const [aadharIntegrationName, setAadharIntegrationName] = useState(aadharIntegrationListFlag?.[0]?.code);
   const disbaledAddharFlag = parseAndSetFlag(outletData?.hideSwitchForAadharApplicantPageFlag);
   const [customerType, setCustomerType] = useState(customerTypeData?.[0]?.code)
  const [showAadharCaptureModal,setShowAadharCaptureModal] = useState(false);
   const [hideVendorName,setHideVendorName] = useState(false);
   const [aadharOtpModal, setAadharOtpModal] = useState(false)
  const [negativePresent,setNegativePresent] = useState(false);
  const [isCustomerInit,setIsCustomerInit] = useState(false);
  const [aadharIntegrationVerified,setAadharIntegrationVerified] = useState(true);
  const [addressDetailsAvailable, setAddressDetailsAvailable] = useState({
        fatherNameState: false,
        houseState: false,
        streetState: false,
        localityState: false,
        postOfficeState: false,
        villageState: false,
        state: false,
        districtState: false,
        pincodeState: false,
        dob:false,
        genderState: false,
      });
const [emailValidationAttempted, setEmailValidationAttempted] = useState({
      success:false,
      error:false,
    });
    const [panValidationAttempted, setPanValidationAttempted] = useState({
      success:false,
      error:false,
    });
    const [aadharValidationAttempted, setAadharValidationAttempted] = useState({
      success:false,
      error:false,
    });
  useEffect(()=>{
    getAllDocumentNames();
    GetStateData();
  },[])
  const getAllDocumentNames = async () =>{
    const result = await apiHandler({
      url: endpoint.GET_ALL_DOCUMENT_NAMES,
      authToken: authToken,
    });
    if(result?.data?.error_code){
      toastUpdate("Error", result?.data?.user_description, true);
    }else {
      let filteredData = [];
      filteredData = result?.data?.filter((item) => !hideDocumentNameDataFlag?.includes(item.displayName));
      setDocumentNameList(filteredData);
    }
  }
  useEffect(()=>{
    if(documentName !== "PASSPORT" && documentName !== "DRIVING_LICENSE"){
      setDocumentExpiry("")
    }
  },[documentName])
  const handleDateChange = (date) => {
    setDateOfBirth(date);
  };
  const ocrVendor = singlePhtotAdhaarOcr ? aadharVendor?.smcAuthBridgeOCR : aadharVendor?.authBridgeOCR
  useEffect(() => {
    if (disbaledAddharFlag) {
      if (aadharThirdPartyAadharEnabled) {
        if (aadharVendorThirdParty ===  ocrVendor) {
          setAadharIntegrationOptions([
            { code: ocrVendor, name: "OCR" }
          ]);
          setAadharIntegrationName(ocrVendor);
        } else {
          const updatedOptions = [];
  
          const vendorOption = aadharIntegrationListFlag.find(
            item => item.code === aadharVendorThirdParty
          );
  
          if (vendorOption) {
            updatedOptions.push(vendorOption);
          } else {
            updatedOptions.push({ code: aadharVendorThirdParty, name: aadharVendorThirdParty });
          }
  
          updatedOptions.push({ code:ocrVendor, name: "OCR" });
  
          setAadharIntegrationOptions(updatedOptions);
          setAadharIntegrationName(updatedOptions[0].code);
        }
      } else {
        setAadharIntegrationOptions([
          { code: "MANUAL", name: "Manual" },
          { code:ocrVendor, name: "OCR" }
        ]);
        setAadharIntegrationName("MANUAL");
      }
       GetApplicationDetails();
    }
  }, [aadharThirdPartyAadharEnabled, disbaledAddharFlag]);
  const handleDocumentExpiry=(date)=>{
    setDocumentExpiry(date)
    setDocumentExpiryState(false)
  }
  const adharNumberSplit =
  aadharTranaction.aadharNumber?.slice(-4) === aadharDetails?.adhaarNumber?.slice(-4);
  useEffect(() => {
    if (adharNumberSplit && aadharDetails?.adhaarNumber && aadharNumber && isAadharAvailable) {
     setAadharIntegrationVerified(false);
     toastUpdate("Information", "Aadhar number is matched", true);
    }
    if (!adharNumberSplit && aadharDetails?.adhaarNumber  && aadharNumber && isAadharAvailable) {
     toastUpdate("Warning", "Aadhar not matched", true);
    }
  }, [aadharDetails && typeof aadharDetails?.adhaarNumber !== "undefined", aadharNumber]);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const handleClose = () => {
    setModalReOpen(false)
    setShowModal(false);
    setEmailState(true);
    setEmailVerify("error");
  };
  const checkedAddress = (e) => {
    if (e.target.checked) {
      setSameAddress(true);
    } else {
      setSameAddress(false);
    }
  };
  useEffect(() => {
    if (applicantDetails?.email && email) {
      setEmailVerify("success");
      setEmailState(false);
    }
  }, [documentNumber]);
  useEffect(() => {
     if (status === loanStatusNames?.aadhaar) {
      updateRecords(aadharTranaction, aadharDetails, aadharVendor?.authBridgeDigiLocker);
     }
  }, [status]);
  useEffect(() => {
    if(!disbaledAddharFlag){
          GetApplicationDetails();
    }
    if(status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie || editable){
      getDigilanceData()
      }
    if (dateOfBirth === "undefined") {
      setDateOfBirth("");
    }
  }, []);
  useEffect(() => {
    if (stateList && stateList.length && aadharDetails && aadharDetails.state) {
      let sl = stateList.filter(
        (s) => s.name.toLowerCase() === aadharDetails.state.toLowerCase()
      );
      if (sl.length > 0) {
        setStateName(sl[0].name);
      }
    }
  }, [stateList, aadharDetails]);
  const handleAadharModalClose = () =>{
    setAadharOtpModal(false)
  }
  const updateRecords = async (transactionId, aadharData, vendor ) => {
      await GetStateData();
    if (transactionId && transactionId.aadharNumber) {
      setAadharNumber(transactionId.aadharNumber);
      setAadharNumberState(false);
      setIsAadharAvailable(transactionId?.isAadharAvailable);
    }
    if (aadharData && aadharData.name) {
      setDocumentDisable(true);
      if (disbaledAddharFlag) {
        if (transactionId && transactionId.aadharNumber) {
          setDocumentNumber(transactionId.aadharNumber);
          setDocumentName(documentNamesList?.aadhaar);
        }
      }
      const pincodeTrim = aadharData?.pincode?.trim();
      const isPincode = isValidPincode(pincodeTrim);
      const postOffice = aadharData?.postOffice?.trim();
      const isPostOffice = isValidateOnlyAlphabets(postOffice, enabledAddressDetailsValidate);
      const villageTownCity = aadharData?.villageTownCity?.trim();
      const isVillageTownCity = isValidateOnlyAlphabets(villageTownCity, enabledAddressDetailsValidate);
      const district = aadharData?.district?.trim();
      const isDistrict = isValidateOnlyAlphabets(district, enabledAddressDetailsValidate);
      setAddressDetailsAvailable({
        fatherNameState: !!aadharData?.fatherName?.trim(),
        houseState: !!aadharData?.houseNumber?.trim(),
        streetState: !!aadharData?.street?.trim(),
        localityState: !!aadharData?.locality?.trim(),
        postOfficeState: isPostOffice,
        villageState: isVillageTownCity,
        state: !!aadharData?.state?.trim(),
        districtState: isDistrict,
        pincodeState: isPincode,
        dob: !!aadharData?.dob?.trim(),
        genderState: !!aadharData?.gender?.trim(),
      });
      if (isDistrict) {
        setDistrict(textFormat(aadharData.district));
        setDistrictState(false);
      }
      if (aadharData.dob) {
        const rawDob = aadharData?.dob;
        const parsedDob = parseDob(rawDob);
        if (parsedDob) {
          setDateOfBirth(parsedDob);
          setDateOfBirthState(false);
        }
      }
      if (aadharData.fatherName) {
        setAadharFatherName(textFormat(aadharData.fatherName));
        setAadharFatherNameState(false);
      }
        setAadharIntegrationName(vendor);
      if (aadharData.houseNumber) {
        setHouseNumber(aadharData.houseNumber);
        setHouseNumberState(false);
      }
      if (aadharData.locality) {
        setLocality(aadharData.locality);
        setLocalityState(false);
      }
      if (aadharData.name) {
        setAadharApplicantName(textFormat(aadharData.name));
        setAadharApplicantNameState(false);
      }
      if (isPostOffice) {
        setPostOffice(aadharData.postOffice);
        setPostOfficeState(false);
      }
      if (aadharData.street) {
        setStreet(aadharData.street);
        setStreetState(false);
      }
      if (isVillageTownCity) {
        setVillageTownCity(textFormat(aadharData.villageTownCity));
        setVillageTownCityState(false);
      }
      if (aadharData.state) {
        setStateName(aadharData.state);
        // setStateNameState(false);
      }
      if (isPincode) {
        setPincode(aadharData?.pincode);
        setPincodeState(false);
      }
      if (aadharData.gender) {
        setGenderDetails(aadharData.gender);
      }
      if (aadharData.name && aadharData.name !== "") {
        setIsAadharAvailable(true);
        setAadharVerified(true);
        setAadharValidationAttempted({ success: true });
      } else {
        setIsAadharAvailable(false);
        setAadharVerified(false);
        setAadharValidationAttempted({ error: true });
      }
    }
  };
  const setGenderDetails = (aadharGender) => {
    switch (aadharGender?.toLowerCase()) {
      case "m":
      case "male":
        setGender(GenderList[0]);
        break;

      case "f":
      case "female":
        setGender(GenderList[1]);
        break;

      default:
        setGender(GenderList[2]);
        break;
    }
  };
  useEffect(()=>{
    const minimumDate = setyear(maxAgeForDateOfBirth);
      const dob = new Date(dateOfBirth);
      if (dob < minimumDate) {
        toastUpdate("Information",`Date of birth can not be less than ${maxAgeForDateOfBirth} years`,true)
      }
  },[dateOfBirth])
  const GetApplicationDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data !== "" && Object.keys(result?.data)?.length > 0) {
      if(status !== "INPROCESS" && status !== "AADHAR"){
        setAddressDetailsAvailable({
            fatherNameState: true,
            houseState: true,
            streetState: true,
            localityState: true,
            postOfficeState: true,
            villageState: true,
            state: true,
            districtState: true,
            pincodeState: true,
            dob:true,
          });
      }
      setApplicantDetailAgainstId(true);
      if(result?.data?.adhaarAvailable){
        setAadharValidationAttempted({success:true});
      }
      if(result?.data?.panVerified){
        setPanValidationAttempted({success:true});
      }
     if(result?.data?.panNumber && !result?.data?.panVerified){
       setPanValidationAttempted({error:true});
    }
      if(result?.data?.email){
        setEmailValidationAttempted({success:true});
      }
      setIsAadharAvailable(result?.data?.adhaarAvailable)
      const name = result?.data?.documentName?.toLowerCase();
        let documentNameUpdate = ""
        if(name === "adhaar card" || name === "aadhar card" || name === "aadhar_card" || name === "adhar_card"){
          documentNameUpdate= "AADHAR_CARD";
        }else if(name === "voter id" || name === "voter_id" || name === "VOTER_ID" || name === "VOTER ID"){
          documentNameUpdate= "VOTER_ID"
        }else if(name === "passport"){
          documentNameUpdate= "PASSPORT" 
        }else if(name === "other"){
          documentNameUpdate= "OTHER"
        }else{
          documentNameUpdate=result?.data?.documentName
        }
      if(!result?.data?.adhaarAvailable && (result?.data?.adhaarNumber || result?.data?.documentNumber) && documentNameUpdate === "AADHAR_CARD"){
        setAadharValidationAttempted({error:true});
        }
        if(documentNameUpdate){
          setDocumentName(documentNameUpdate  || "")
        }
        setMotherName((result.data && result?.data?.motherName) || "");
        setPreFixName(result?.data?.applicantNamePrefix || "Mr");
        setDocumentExpiry(result?.data?.documentExpiry || "")
        if(result?.data?.dueDiligence){
          setDigilance(true)
          setDigilanceState(result?.data?.dueDiligence || "")
        }
        setMateritalStatus((result.data && result?.data?.maritalStatus) || "");
        setAnnualIncome((result.data && result?.data?.applicantAnnualIncome) || "0");
        setMemberCount((result.data && result?.data?.memberCount) || "");
        setSpouseName((result.data && result?.data?.spouseName) || "");
        if(!result?.data?.aadhaarVendor && typeof result?.data?.aadhaarVendor === "undefined" && result.data?.aadhaarVendor === null){
          setHideVendorName(true);
        }
        if(result?.data?.adhaarAvailable){
          setAadharNumber(result?.data?.adhaarNumber?.replace(/\s+/g, ''));
          setDocumentNumber(result?.data?.adhaarNumber?.replace(/\s+/g, ''));
          setAadharIntegrationName(result?.data?.aadhaarVendor);
           if(disbaledAddharFlag){
          setDocumentName('AADHAR_CARD')
        }
        }else{
        setDocumentNumber(result?.data?.documentNumber)}
      if(result?.data?.nameOnAdhaar){
        setAadharApplicantName(result?.data?.nameOnAdhaar || "")
        }else{
          setAadharApplicantName(result?.data?.nameOnPanCard || PanNameObj)
        }
      setAadharIntegrationVerified(false);
      setNegativePresent(result?.data?.customerRisk);
      setAadharFatherName(result?.data?.fatherName || "");
      setDateOfBirth(result?.data?.dob || "")
      setEmail(result?.data?.email || "");
      setMobileNumber(result?.data?.alternateMobileNumber?.trim() || "")
      setGstNumber(result?.data?.gstNumber || "")
      setGst(result?.data?.gstState || "")
      setSameAddress(result?.data?.sameAddress || "")
      setHouseNumber(result?.data?.addresses?.[0]?.houseNumber || "")
      setStreet(result?.data?.addresses?.[0]?.street || "")
      setNameOnPanCard(result?.data?.nameOnPanCard || PanNameObj)
      setPanNumber(result?.data?.panNumber || PanNumberObj);
      if(result?.data?.panNumber && result?.data?.nameOnPanCard){
        setPanNumberDisabled(true)
      }
      setLocality(result?.data?.addresses?.[0]?.locality || "")
      if(result?.data?.addresses?.[0]?.pincode){
        setPincode(result?.data?.addresses?.[0]?.pincode || "")
      }
      if(result?.data?.addresses?.[0]?.postOffice){
        setPostOffice(result?.data?.addresses?.[0]?.postOffice || "")
      }
      setDistrict(result?.data?.addresses?.[0]?.district || "")
      if(result?.data?.addresses?.[0]?.villageTownCity){
        setVillageTownCity(result?.data?.addresses?.[0]?.villageTownCity || "")
      }
      setStateName(result?.data?.addresses?.[0]?.state || "")
      setCustomerType(result?.data?.customerType)
      if(result?.data?.occupationType){
          if(OccupationList?.includes(result?.data?.occupationType)){
            setoccupationTypes(result?.data?.occupationType)
          }else{
            setoccupationTypes(OccupationList?.[0])
          }
       }
       if(result?.data?.purposeOfLoan){
          if(PurposeOfLoan?.includes(result?.data?.purposeOfLoan)){
            setPurposeOfLoan(result?.data?.purposeOfLoan)
          }else{
            setPurposeOfLoan(PurposeOfLoan?.[0])
          }
      }
      setGender(result?.data?.gender || "Male")
      const correspondingData=result?.data?.addresses.filter((item) => item.addressType === "RESIDENTIAL_ADDRESS" || item?.addressType==="CORRESPONDENCE_ADDRESS");
        setCoresHouseNumber(correspondingData?.[0]?.houseNumber|| "")
        setCoresDistrict(correspondingData?.[0]?.district|| "")
        setCoresLocality(correspondingData?.[0]?.locality|| "")  
        setCoresPinCode(correspondingData?.[0]?.pincode|| "")
        setCoresPostOffice(correspondingData?.[0]?.postOffice|| "")
        setCoresState(correspondingData?.[0]?.state|| "")
        setCoresStreet(correspondingData?.[0]?.street|| "")
        setCoresVillage(correspondingData?.[0]?.villageTownCity|| "")
        if(!result?.data?.email || result?.data?.email?.trim() === ""){
          getLoanDetails()
        }
        if((!result?.data?.documentNumber || result?.data?.documentNumber?.trim() === "") && (!result?.data?.adhaarNumber || result?.data?.adhaarNumber?.trim() === "") && result?.data?.panNumber ){
          SearchProfileData(result?.data?.panNumber, functionVariableNamesList?.panNumber)
        }
        if(disabledApplicantLoanDetailsFlag && status === "INPROCESS"){
          setCallInProgress(true);
          const searchQueryParams = result?.data?.documentNumber || result?.data?.adhaarNumber;
          const res = await apiHandler({
            url: endpoint.SEARCH_PROFILE + searchQueryParams,
            authToken: authToken,
          });
          setCallInProgress(false);
          if(res?.data?.length === 1 && mobileNum === res?.data?.[0]?.communication?.primarymobileNumber){
            setDisabledFields(true);
             setAadharIntegrationVerified(false);
          }
        }
    }else{
      setIsAadharAvailable(false)
      setApplicantDetailAgainstId(false)
      SearchProfileData()
      if(customerBasedDigiLocker){
       const storedData =
          JSON.parse(sessionStorage.getItem("loanApplicationData")) || [];
        const matchedLoan = storedData.find(
          item => item.loanApplicationId === loanApplicationId
        );
          await checkAadharDetails(false ,true, matchedLoan?.vendorName);
      }
      await getLoanDetails()
    }
  };
  const GetStateData = async () => {
    const result = await apiHandler({
      url: endpoint.MASTER_STATE_FINDALL,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      result?.data?.sort(function(a, b) { 
        return  a.name.localeCompare(b.name);});
      setStateList(result.data);
    }
  };

  const GetPRofile = async (result) => {
  const panArray= result?.identification?.filter((item)=> item?.identificationType?.toLowerCase() === 'pan')
    const documentArray = result?.identification?.filter((item)=> item?.identificationType?.toUpperCase() !== 'PAN')
    const name = documentArray?.[0]?.documentName?.toLowerCase();
    let documentName = ""
    if(name === "adhaar card" || name === "aadhar card" || name === "aadhar_card" || name === "adhar_card"){
      documentName= "AADHAR_CARD";
    }else if(name === "voter id" || name === "voter_id" || name === "VOTER_ID" || name === "VOTER ID"){
      documentName= "VOTER_ID"
    }else if(name === "passport"){
      documentName= "PASSPORT" 
    }else if(name === "other"){
      documentName= "OTHER"
    }else{
      documentName=documentArray?.[0]?.documentName
    }
    if(panArray?.length > 0){
      if(panArray?.[0]?.verified){
       setPanValidationAttempted({success:true});
       setPanVerified(true);
      }
      if(!panArray?.[0]?.verified){
        setPanValidationAttempted({error:true});
        setPanVerified(false);
      }
    }
    if (result?.adharNumber !== undefined && result?.adharNumber !== null) {
    setAadharIntegrationName(documentArray?.[0]?.vendor || ocrVendor);
    setAadharNumber(result?.adharNumber)
    setDocumentDisable(true);
    setIsAadharAvailable(true);
    if (documentArray?.[0]?.verified) {
      setAadharValidationAttempted({ success: true });
    } else {
      setAadharValidationAttempted({ error: true });
    }
    if(disbaledAddharFlag){
      setDocumentName(documentName);
      setDocumentNumber(documentArray?.[0]?.identificationNum);
    }
  }else{
    if (documentArray?.length > 0) {
    setDocumentName(documentName);
    setDocumentNumber(documentArray?.[0]?.identificationNum);
    setDocumentDisable(true);
  }
  }

    if (result && result.applicantName) {
      onNewCustomer(false);
    } else {
      onNewCustomer(true);
    }
    documentLink(result.documentLinks);
    if (
      result &&
      result.communication &&
      result.communication.primaryEmail
    ) {
      setEmailState(false);
      setEmailVerify("success");
      setEmailState(false);
    }
    setEmail(
      (result &&
        result.communication &&
        result.communication.primaryEmail) ||
        ""
    );
    setDocumentExpiry(result?.documentExpiry || documentArray?.[0]?.documentExpiry)
    if((result?.panNumber || PanNumberObj) && (result?.nameOnPanCard || PanNameObj)){
      setNameOnPanCard(result?.nameOnPanCard || PanNameObj)
      setPanNumber(result?.panNumber || PanNumberObj)
      if(result?.panNumber && result?.nameOnPanCard){
        setPanNumberDisabled(true)
      }
    }
    setAadharApplicantName(
      (result && textFormat(result.applicantName)) || ""
    );
    setDateOfBirth(
      result.dateOfBirth ? new Date(result.dateOfBirth) : ""
    );
    if (result && result.applicantName)
      setAadharApplicantNameState(false);
    if (result && result.dateOfBirth) {
      setDateOfBirthState(false);
    }
    setAadharFatherName((result && result.fatherName) || "");
    if(result?.occupationType){
      if(OccupationList?.includes(result?.occupationType)){
        setoccupationTypes(result?.occupationType)
      }else{
        setoccupationTypes(OccupationList?.[0])
      }
    }
    if(result?.purposeOfLoan){
      if(PurposeOfLoan?.includes(result?.purposeOfLoan)){
        setPurposeOfLoan(result?.purposeOfLoan)
      }else{
        setPurposeOfLoan(PurposeOfLoan?.[0])
      }
    }
    if (result && result.fatherName)
      setAadharFatherNameState(false);
    setHouseNumber(
      (
        textFormat(result?.address?.[0]?.fullAddress?.houseNo)) ||
        ""
    );
    if (
      result?.address?.[0]?.fullAddress?.houseNo
    )
      setHouseNumberState(false);
    setStreet(
      (result?.address?.[0]?.fullAddress?.street) ||
        ""
    );
    if(result?.dueDiligence){
      setDigilance(true)
      setDigilanceState(result?.data?.dueDiligence || "")
    }
    setMotherName(result?.motherName);
    setPreFixName(result?.applicantNamePrefix || 'Mr')
    setMateritalStatus(result?.maritalStatus);
    setAnnualIncome(result?.applicantAnnualIncome || "0")
    setMemberCount(result?.memberCount);
    setSpouseName(result?.spouseName);
    setGender(result?.gender || 'Male');
    if (
      result?.address?.[0]?.fullAddress?.street
    )
      setStreetState(false);
    setLocality(
      (result?.address?.[0]?.fullAddress?.locality) ||
        ""
    );
    if (
      result?.address?.[0]?.fullAddress?.locality
    )
      setLocalityState(false);
    if(isValidateOnlyAlphabets(result?.address?.[0]?.fullAddress?.postOffice, enabledAddressDetailsValidate)){
    setPostOffice(
      (result?.address?.[0]?.fullAddress?.postOffice) ||
        ""
    );
    if (
      result?.address?.[0]?.fullAddress?.postOffice
    )
      setPostOfficeState(false);
    }
    if(isValidateOnlyAlphabets(result?.address?.[0]?.fullAddress?.city, enabledAddressDetailsValidate)){
    setVillageTownCity(
      (
        textFormat(result?.address?.[0]?.fullAddress?.city)) ||
        ""
      );
      if (
        result?.address?.[0]?.fullAddress?.city
      )
      setVillageTownCityState(false);
    }
    setStateName(
      textFormat(
        result?.address?.[0]?.fullAddress?.state) ||
        ""
    );
    if (
      result?.address?.[0]?.fullAddress?.state
    )
      setStateNameState(false);
    if(isValidateOnlyAlphabets(result?.address?.[0]?.fullAddress?.district, enabledAddressDetailsValidate)){
      setDistrict(textFormat(result?.address?.[0]?.fullAddress?.district) || "");
    }
    if (
      result?.address?.[0]?.fullAddress?.district
    )
      setDistrictState(false);
      if(isValidPincode(result?.address?.[0]?.fullAddress?.pincode)){
        setPincode(
          (result?.address?.[0]?.fullAddress?.pincode) ||
            ""
        );
        if (
          result?.address?.[0]?.fullAddress?.pincode
        )
          setPincodeState(false);
    }
    setMobileNumber(
      (
        result?.communication?.alternateMobileNumber?.trim()) ||
        ""
    );
    if (
     
      result?.communication?.alternateMobileNumber?.length === 10
    )
      setMobileNumberState(false);
      if(result?.occupationType){
        if(OccupationList?.includes(result?.occupationType)){
          setoccupationTypes(result?.occupationType)
        }else{
          setoccupationTypes(OccupationList?.[0])
        }
      }
      if(result?.purposeOfLoan){
        if(PurposeOfLoan?.includes(result?.purposeOfLoan)){
          setPurposeOfLoan(result?.purposeOfLoan)
        }else{
          setPurposeOfLoan(PurposeOfLoan?.[0])
         }
     }
    setCoresHouseNumber(
      (
        textFormat(result?.address?.[1]?.fullAddress?.houseNo)) ||
        ""
    );
    if (
      result?.address?.[1]?.fullAddress?.houseNo
    )
    setHouseCorrNumberState(false);
    setCoresStreet(
      (result?.address?.[1]?.fullAddress?.street) ||
        ""
    );
    if (
      result?.address?.[1]?.fullAddress?.street
    )
    setStreetCorrState(false);
    setCoresLocality(
      (result?.address?.[1]?.fullAddress?.locality) ||
        ""
    );
    if (
      result?.address?.[1]?.fullAddress?.locality
    )
      setLocalityCorrState(false);
    setCoresPostOffice(
      (result?.address?.[1]?.fullAddress?.postOffice) ||
        ""
    );
    if (
      result?.address?.[1]?.fullAddress?.postOffice
    )
      setPostOfficeCorrState(false);
    setCoresVillage(
      (
        textFormat(result?.address?.[1]?.fullAddress?.city)) ||
        ""
    );
    if (
     
      result?.address?.[1]?.fullAddress?.city
    )
      setVillageTownCityCorrState(false);
    setCoresState(
      textFormat(
        result?.address?.[1]?.fullAddress?.state) ||
        ""
    );
    if (
      result?.address?.[1]?.fullAddress?.state
    )
      setStateNameCorrState(false);
    setCoresDistrict(
      (
        textFormat(result?.address?.[1]?.fullAddress?.district)) ||
        ""
    );
    if (
      result?.address?.[1]?.fullAddress?.district
    )
      setDistrictCorrState(false);
    setCoresPinCode(
      (result?.address?.[1]?.fullAddress?.pincode) ||
        ""
    );
    if (
      result?.address?.[1]?.fullAddress?.pincode
    )
      setPincodeCorrState(false);
};
const SearchProfileData = async (value, blured) => {
  if(blured && enableNegativeProfileCheck){
      const panValue = blured === "PAN" ? true : false;
      const apiReponse = await checkNegativeProfileApi(apiHandler,
      endpoint,
      authToken,
      setCallInProgress,
      toastUpdate,
      !panValue ? value : null,
      panValue ? value : null,)
      if (apiReponse?.[0]?.risk) {
        setNegativePresent(apiReponse?.[0]?.risk)
        proceedApplication();
      }
    }
  setCallInProgress(true);
  let queryParams = ""
    if(blured === functionVariableNamesList?.panNumber){
      queryParams =`${mobileNum?.trim()},${value?.trim()}`
    }else if(panNumber && value){
     queryParams= `${mobileNum?.trim()},${panNumber?.toUpperCase()?.trim()},${value?.trim()}`
    }else if(panNumber){
     queryParams= `${mobileNum?.trim()},${panNumber?.toUpperCase()?.trim()}`
    }else if(value){
      queryParams = `${mobileNum?.trim()},${value?.trim()}`
    }else{
      queryParams = `${mobileNum?.trim()}`
    }
  const errorMessage =  "Document Number is Linked with other customer";
  const errorMessgae1 = blured === "withPanNumber" ?  "Pan is Linked with other customer" : errorMessage
  const res = await apiHandler({
    url: endpoint.SEARCH_PROFILE + queryParams,
    authToken: authToken,
  });
  setCallInProgress(false);
  if(res?.data?.length > 1){

    toastUpdate("Error", errorMessage, true);
  }else if(res?.data?.length === 1){
     setAadharIntegrationVerified(false);
    if(blured === "aadharBlur"){
      setAadharNumber('');
      setIsAadharAvailable(false);
    }
    if(mobileNum !== res?.data?.[0]?.communication?.primarymobileNumber){
      toastUpdate("Error", errorMessgae1, true);
      
      setLoanStatus(true);
    }
    else{
       if(blured === "PAN"){
        verifyPAN();
    }else{
        GetPRofile(res?.data?.[0]);
        if(disabledApplicantLoanDetailsFlag){
          setDisabledFields(true);
        }
        setLoanStatus(false);
        if(enabledReKycForDocumentVerification){
           setHideVendorName(false);
           if (blured === "aadhar") {
             if (aadharIntegrationName === aadharVendor?.authBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker)  {
                 handleAadharCaptureData();
               } else if (aadharIntegrationName === aadharVendor?.authBridgeOCR) {
                 setShowAadharCaptureModal(true);
               } else if (aadharIntegrationName === aadharVendor?.surePass) {
                 handleAadharCaptureData();
               }
             setLoanStatus(false);
           }
         }else{
           setHideVendorName(true);
            if((blured === "" || blured === undefined) && enableNegativeProfileCheck){
              const apiReponse = await checkNegativeProfileApi(apiHandler,
                endpoint,
                authToken,
                setCallInProgress,
                toastUpdate,
                res?.data?.[0]?.adharNumber,
                res?.data?.[0]?.panNumber,)
                if (apiReponse?.[0]?.risk) {
                  setNegativePresent(apiReponse?.[0]?.risk)
                  proceedApplication();
                }
            }
         }
      }
    }
  }else{
    setHideVendorName(false);
    if(blured === functionVariableNamesList?.aadhaar){
            if (aadharIntegrationName === aadharVendor?.authBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcEKYC) {
            handleAadharCaptureData();
          } else if (aadharIntegrationName ===  ocrVendor) {
            setShowAadharCaptureModal(true);
          } else if (aadharIntegrationName === aadharVendor?.surePass) {
            handleAadharCaptureData();
          }
        setLoanStatus(false);
      }
        if(blured === "aadharBlur"){
          setDocumentNumber('');
        }
        if(blured === "PAN"){
          verifyPAN();
        }
        setLoanStatus(false);
    }
  };
  const verifyAadharOtp = async (code) =>{
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.AADHAR_DETAILS,
      method: "POST",
      authToken: authToken,
      data:{
        transactionId: tsTransID,
        otp:code,
        vendor:aadharIntegrationName,
      }
    });
    setCallInProgress(false);
      setShowModal(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
      } else {
        setAadharOtpModal(false);
        const aadharDetailsNumber = aadharNumber ?? documentNumber;
        const aadharTransaction = {
          transactionId: tsTransID,
          loanApplicationId,
          loanApplicationNumber,
          aadharNumber: aadharDetailsNumber,
          aadharTransaction,
        }
        setApplicantDetailAgainstId(true);
        updateRecords(aadharTransaction, res?.data, aadharVendor?.surePass)
      }
  }
  const verifyPAN = async () => {
    setCallInProgress(true);
    const response = await apiHandler({
      url: endpoint.NEW_PAN_CARD_VERIFY,
      authToken: authToken,
      method: "POST",
      data: {
        panNumber: panNumber?.toUpperCase(),
        dob:parseDate(dateOfBirth),
        name:aadharApplicantName
      },
    });
    setCallInProgress(false);
    if(response?.data?.error_code){
    toastUpdate("Error", response.data?.user_description, true);
    setPanVerified(false);
    setPanValidationAttempted({error:true});
    }else {
      setNameOnPanCard(response?.data?.name);
      setPanNumber(response?.data?.panCard);
      setPanVerified(true);
      setPanNumberDisabled(true);
      setPanValidationAttempted({success:true});
    }
  };
  const sendEMailOtp = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.APPLICANT_EMAIL_OTP,
      method: "POST",
      authToken: authToken,
      data: {
        type: "EMAIL",
        source: email?.toLowerCase(),
        messageType: 0,
        otp: "null",
      },
    });
    setCallInProgress(false);
    setId(res?.data?.id);
    if (res?.data?.id) {
      setShowModal(true);
    }
  };
  const verifyOtp = async (otp) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.APPLICANT_EMAIL_VERIFY + id + "/" + otp,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    setShowModal(false);
    if(res?.data?.error_code) {
      setEmailValidationAttempted({error:true});
      setEmailVerify("error");
      setEmailState(true);
      // setEmail('');
      toastUpdate("Error", res?.data?.user_description, true);
      setTimeout(() => {
        setShowModal(true);
        setModalReOpen(true)
        },3000)
    }
    else{
      setModalReOpen(false)
      setEmailVerify("success");
      setEmailState(false);
      setEmailValidationAttempted({success:true});
      toastUpdate("Success", "Email verified successfully", true);
    }
  };
  const getLoanDetails = async () => {
    // Get Loan Application Details
    const result = await apiHandler({
      url: endpoint.CUSTOMER_APPLICATIONFINDID + loanApplicationId,
      authToken: authToken,
    });
    if(result?.data?.email){
        setEmailValidationAttempted({success:true});
      setEmail(result?.data?.email)
        setEmailVerify("success")
    }
  };
  const getDigilanceData = async () => {
    // Get Loan Application Details
    const result = await apiHandler({
      url: endpoint.FIND_DIGILLANCE,
      authToken: authToken,
    });
    if(result?.data){
   setDigilanceData(result?.data)
  }
  };
  const aadharCardValidate = (aadhar) => {
    var adharcardTwelveDigit = /^\d{12}$/;

    if (aadhar !== "") {
      if (aadhar.match(adharcardTwelveDigit)) {
        setDocumentNumberState(false);
        return true;
      } else {
        setDocumentNumberState(true);
        toastUpdate("Error", "Enter valid Aadhar Number", true);
        return false;
      }
    }
  };

  const isValidated = () => {
      if(aadharIntegrationVerified && documentName === documentNamesList?.aadhaar && aadharIntegrationName !== aadharVendor?.manual){
        toastUpdate("Error","Please do aadhar verification first",true);
        return;
      }
      if((documentName === "PASSPORT" || documentName === "DRIVING_LICENSE") && (documentExpiry === "" || typeof documentExpiry === "undefined" || documentExpiry === null)){
        setDocumentExpiryState(true)
      }else{
        setDocumentExpiryState(false)
      }
      if(showPreFixName && ((prefixName === "Mr" && gender === "Female") || ((prefixName === "Mrs" || prefixName === "Miss") && gender === "Male"))){
        setPreFixNameState(true);
      }else{
        setPreFixNameState(false);
      }
        if (motherName?.trim() === "" || typeof motherName === "undefined") {
          setMotherNameErrorState(true);
        } else {
          setMotherNameErrorState(false);
        }
        if (maritalStatus === "Married" && (spouseName === "" || typeof spouseName === "undefined")) {
          setSpouseNameState(true);
          return false;
        } else {
          setSpouseNameState(false);
        }
        if (maritalStatus === "" || typeof maritalStatus === "undefined") {
          setmaritalStatusState(true);
        } else {
          setmaritalStatusState(false);
        }
        if (memberCount === "" || typeof memberCount === "undefined") {
          setMemberCountError(true);
        } else {
          setMemberCountError(false);
        }
          if(documentName===''  || typeof documentName === "undefined"){
            setDocumentNameState(true);
          }else{
            setDocumentNameState(false);
          }      
          if(documentNumber==="" || typeof documentNumber === "undefined"){
            setDocumentNumberState(true);
          }else{
            setDocumentNumberState(false);
          }
          if(aadharApplicantName?.trim() === '' ||
          typeof aadharApplicantName === "undefined"){
            setAadharApplicantNameState(true);
          } else{
            setAadharApplicantNameState(false);
          }
          if(nameOnPanCard === '' ||
          typeof nameOnPanCard === "undefined"){
            setNameOnPanCardState(true);
          } else{
            setNameOnPanCardState(false);
          }
          if(aadharFatherName?.trim() ==="" || typeof aadharFatherName === "undefined"){
            setAadharFatherNameState(true);
          }else{
            setAadharFatherNameState(false);
          }
          const minimumDate = setyear(maxAgeForDateOfBirth);
          const dob = new Date(dateOfBirth);
          if (dob < minimumDate) {
            setDateOfBirthState(true);
            return false;
          } else {
            setDateOfBirthState(false);
          }
          if (dateOfBirth === "" || typeof dateOfBirth === "undefined" || parseDate(dateOfBirth) === 'NaN-NaN-NaN') {
            setDateOfBirthState(true);
          }else{
            setDateOfBirthState(false)
          }
          if(houseNumber ==='' || typeof houseNumber === "undefined"){
            setHouseNumberState(true)
          }else{
            setHouseNumberState(false);
          }
          if(street === '' || typeof street === "undefined"){
            setStreetState(true)
          }else{
            setStreetState(false)
          }
          if(locality==='' || typeof locality === "undefined"){
            setLocalityState(true)
          }else{
            setLocalityState(false)
          }
          if(postOffice === '' || typeof postOffice === "undefined"){
            setPostOfficeState(true)
          }else{
            setPostOfficeState(false)
          }
          if(villageTownCity==='' || typeof villageTownCity === "undefined"){
            setVillageTownCityState(true)
          }else{
            setVillageTownCityState(false)
          }
          if (stateName === "" || typeof stateName === "undefined") {
            setStateNameState(true);
          }else{
            setStateNameState(false)
          }
          if(district==='' || typeof district === "undefined"){
            setDistrictState(true)
          }else{
            setDistrictState(false)
          }
          if(pincode==='' || typeof pincode === "undefined" || !isValidPincode(pincode)){
            setPincodeState(true)
          }
          else{
            setPincodeState(false)
          }
          if (annualIncome === "" || typeof annualIncome === "undefined" || Number(annualIncome) < Number(annualIncomeAmount)) {
            setAnnualIncomeState(true);
          } else {
            setAnnualIncomeState(false);
          }
          if (mobileNumber && mobileNumber.length !== 10) {
            setMobileNumberState(true);
          } else {
            setMobileNumberState(false);
          }
          if(emailVerify==='error'){
            setEmailState(true)
          }else{
            setEmailState(false)
          }
          if(sameAddress ? houseNumber==="" : coresHouseNumber==="" || typeof coresHouseNumber === "undefined"){
            sameAddress ? setHouseNumberState(true) : setHouseCorrNumberState(true);
          }else{
            sameAddress ? setHouseNumberState(false) : setHouseCorrNumberState(false);
          }
          if(sameAddress?street==="":coresStreet===""|| typeof coresStreet === "undefined"){
            sameAddress?setStreetState(true):setStreetCorrState(true);
          }else{
            sameAddress?setStreetState(false):setStreetCorrState(false);
          }
          if(sameAddress?locality==="":coresLocality===""|| typeof coresLocality === "undefined"){
            sameAddress?setLocalityState(true):setLocalityCorrState(true);
          }else{
            sameAddress?setLocalityState(false):setLocalityCorrState(false);
          }
          if(sameAddress?postOffice==="" :coresPostOffice===""|| typeof coresPostOffice === "undefined"){
            sameAddress? setPostOfficeState(true): setPostOfficeCorrState(true);
          }else{
            sameAddress?setPostOfficeState(false):setPostOfficeCorrState(false);
          }
          if(sameAddress?villageTownCity==="":coresVillage===""|| typeof coresVillage === "undefined"){
            sameAddress?setVillageTownCityState(true):setVillageTownCityCorrState(true);
          }else{
            sameAddress?setVillageTownCityState(false):setVillageTownCityCorrState(false);
          }
          if(sameAddress?stateName==="":coresState===""|| typeof coresState === "undefined"){
            sameAddress?setStateNameState(true):setStateNameCorrState(true);
          }else{
            sameAddress?setStateNameState(false):setStateNameCorrState(false);
          }
          if(sameAddress?district==="":coresDistrict===""|| typeof coresDistrict === "undefined"){
            sameAddress?setDistrictState(true):setDistrictCorrState(true);
          }else{
            sameAddress?setDistrictState(false):setDistrictCorrState(false);
          }
          if(sameAddress?(pincode===""|| !isValidPincode(pincode)):(coresPinCode===""|| typeof coresPinCode === "undefined" || !isValidPincode(coresPinCode))){
            sameAddress?setPincodeState(true):setPincodeCorrState(true);
          }else{
            sameAddress?setPincodeState(false):setPincodeCorrState(false);
          }
          // }
          if (digilance && (digilanceState === "" || typeof digilanceState === "undefined")){
            setDueDigilance(true);
            return false;
          }else{setDueDigilance(false)}
          if(email && emailVerify === "error" || email==='' && emailVerify === "error"){
            return false
          }
          if (
            (isAadharAvailable ? 
            aadharNumber &&
            aadharNumber !== ""
            : documentName &&
            documentName !== "" &&
            documentNumber &&
            documentNumber !== "" ) &&
            dateOfBirth &&
            dateOfBirth !== "" &&
            parseDate(dateOfBirth) !== 'NaN-NaN-NaN' && 
            aadharFatherName &&
            aadharFatherName?.trim() !== "" &&
            aadharApplicantName &&
            aadharApplicantName?.trim() !== "" &&
            houseNumber &&
            houseNumber !== "" &&
            street &&
            street !== "" &&
            locality &&
            locality !== "" &&
            postOffice &&
            postOffice !== "" &&
            villageTownCity &&
            villageTownCity !== "" &&
            district &&
            district !== "" &&
            pincode &&
            isValidPincode(pincode) &&
            stateName &&
            stateName !== "" &&
            motherName &&
      motherName?.trim() !== "" &&
      memberCount &&
      memberCount !== "" &&
      annualIncome &&
      annualIncome !== "" &&
      Number(annualIncome) >= Number(annualIncomeAmount) &&
      maritalStatus &&
      maritalStatus !== "" &&
      ((documentName === "PASSPORT" || documentName === "DRIVING_LICENSE") && documentExpiry !== "" || (documentName !== "PASSPORT" && documentName !== "DRIVING_LICENSE")) &&
            (sameAddress
            
              ? houseNumber &&
                houseNumber !== "" &&
                pincode &&
                isValidPincode(pincode) &&
                street &&
                street !== "" &&
                locality &&
                locality !== "" &&
                villageTownCity &&
                villageTownCity !== "" &&
                district &&
                district !== "" &&
                postOffice &&
                postOffice !== "" &&
                stateName &&
                stateName !== "" &&
                ((mobileNumber && mobileNumber.length === 10) || !mobileNumber)
              : coresHouseNumber &&
                coresHouseNumber !== "" &&
                coresStreet &&
                coresStreet !== "" &&
                coresDistrict &&
                coresDistrict !== "" &&
                coresVillage &&
                coresVillage !== "" &&
                coresLocality &&
                coresLocality !== "" &&
                coresPostOffice &&
                coresPostOffice !== "" &&
                coresPinCode &&
                isValidPincode(coresPinCode) &&
                coresState &&
                coresState !== "" &&
                houseNumber &&
                houseNumber !== "" &&
                pincode &&
                isValidPincode(pincode) &&
                street &&
                street !== "" &&
                locality &&
                locality !== "" &&
                villageTownCity &&
                villageTownCity !== "" &&
                district &&
                district !== "" &&
                postOffice &&
                postOffice !== "" &&
                stateName &&
                stateName !== "") &&
                 ((mobileNumber && mobileNumber.length === 10) || !mobileNumber) 
          ) {
            if (documentName === "AADHAR_CARD") {
              return aadharCardValidate(documentNumber);
            } else {
              return true;
            }
          } else {
            return false;
          }
        };
        const isPanValidate = ()=>{
          if(panNumber && panNumber?.length < 10 && (nameOnPanCard === "" || typeof nameOnPanCard === "undefined" || nameOnPanCard === null)){
            return false
          }else{
            return true
          }
        }

  const handlecreateapplicantSubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (isValidated() && isPanValidate()) {
      toastUpdate("", "", false);;
      setCallInProgress(true);
      const data = {
        loanApplicationId: loanApplicationId,
        email: email && email !== "" ? email?.toLowerCase() : "",
        panNumber: panNumber && panNumber !== "" ? panNumber : null,
        nameOnPanCard:
          nameOnPanCard && nameOnPanCard !== "" ? nameOnPanCard : null,
        adhaarNumber:
          aadharNumber && aadharNumber !== "" ? aadharNumber : null,
        nameOnAdhaar:
          aadharApplicantName && aadharApplicantName !== ""
            ? aadharApplicantName
            : nameOnPanCard,
        dob: parseDate(dateOfBirth),
        fatherName:
          aadharFatherName && aadharFatherName !== ""
            ? aadharFatherName
            : null,
            dueDiligence:digilanceState,
        addresses: [
          {
            addressType: "PERMANENT_ADDRESS",
            houseNumber:
              houseNumber && houseNumber !== "" ? houseNumber : null,
            street: street && street !== "" ? street : null,
            locality: locality && locality !== "" ? locality : null,
            postOffice: postOffice && postOffice !== "" ? postOffice : null,
            villageTownCity:
              villageTownCity && villageTownCity !== ""
                ? villageTownCity
                : null,
            state: stateName && stateName !== "" ? stateName : null,
            district: district && district !== "" ? district : null,
            pincode: pincode && pincode !== "" ? pincode : null,
          },
          {
            addressType: "RESIDENTIAL_ADDRESS",
            houseNumber: sameAddress ? houseNumber : coresHouseNumber,
            street: sameAddress ? street : coresStreet,
            locality: sameAddress ? locality : coresLocality,
            postOffice: sameAddress ? postOffice : coresPostOffice,
            villageTownCity: sameAddress
              ? villageTownCity
              : coresVillage,
            state: sameAddress ? stateName : coresState,
            district: sameAddress ? district : coresDistrict,
            pincode: sameAddress ? pincode : coresPinCode,
          },
        ],
        documentName:
          (disbaledAddharFlag && isAadharAvailable) ? null : documentName && documentName !== "" ? documentName : null,
        documentNumber:
          (disbaledAddharFlag && isAadharAvailable) ? null : documentNumber && documentNumber !== "" ? documentNumber : null,
        alternateMobileNumber:
          mobileNumber && mobileNumber !== "" ? mobileNumber?.trim() : null,
        gender: (gender) || "Male",
        occupationType:
         occupationTypes ||  OccupationList?.[0],
        purposeOfLoan: purposeOfLoan || PurposeOfLoan?.[0],
        gstNumber: gstNumber || "",
        gstState: gst || "",
        sameAddress: sameAddress || false,
        adhaarAvailable: isAadharAvailable,
        spouseName: maritalStatus === "Single" ? "NA"  : spouseName || "NA",
        maritalStatus: maritalStatus || '',
        memberCount: memberCount|| '',
        applicantAnnualIncome: annualIncome || '',
        motherName: motherName || '',
        applicantNamePrefix: prefixName || "Mr",
        documentExpiry: (documentName === "PASSPORT" || documentName === "DRIVING_LICENSE") ? parseDate(documentExpiry) : '',
        aadhaarVendor: isAadharAvailable ? aadharIntegrationName : '',
        panVerified: panVerified || false,
        customerRisk:negativePresent || false,
           ...(showCustomerType && {customerType: customerType})
      }
      const res = await apiHandler({
        url: endpoint.ADMIN_APPLICANT_CREATE,
        method: "POST",
        authToken: authToken,
        data: data
        
      });
      //this.setState({ -: false });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Create Applicant successfully", true);
        dispatch(
          saveLoanApplicantDetails({
            applicantDetails: data,
          })
        );
        setNext();
      }
    } else {
      const minimumDate = setyear(maxAgeForDateOfBirth);
      const dob = new Date(dateOfBirth);
      if (dob < minimumDate) {
        toastUpdate("Information",`Date of birth can not be less than ${maxAgeForDateOfBirth} years`,true)
        return true;
      }else if (documentName === "AADHAR_CARD") {
        return aadharCardValidate(documentNumber);
      } else {
        toastUpdate("Error", "Please fill all the fields", true);
        return false;
      }
    }
  };
  // cancel button function
  const handlecancelapplicant = () => {
    dispatch(saveAadharDetails(""));
    setBack();
  };

   const handleAadharCaptureData = async (document1, document2) => {
      const formData = new FormData();
      if(document1?.file){
      formData.append("frontImage", document1.file, document1.name);
      }
      if(document2?.file){
      formData.append("backImage", document2.file, document2.name);
      }
      formData.append("data",JSON.stringify({
          redirectUrl: window.location.origin  + "/aadhar-oauth",
          adhaarNumber: aadharNumber ?? documentNumber,
          vendor: aadharIntegrationName,
          customerName:aadharApplicantName,
          mobileNumber:mobileNum,
          loanApplicationId:loanApplicationId,
        })
      );
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.AADHAR_INIT,
        method: "POST",
        authToken,
        data: formData,
      });
      setCallInProgress(false);
      if (result?.data?.error_code || result?.data?.error) {
        toastUpdate( "Error",result?.data?.user_description || result?.data?.error,true );
      } else {
        let intervalId;  
        if (customerBasedDigiLocker  && aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker) {
          toastUpdate("Information", "Customer Based Authentication initiated", true);
           const storageKey = "loanApplicationData";
          const existingData = JSON.parse(sessionStorage.getItem(storageKey)) || [];
          const index = existingData.findIndex(
            item => item.loanApplicationId === loanApplicationId
          );
          if (index !== -1) {
            existingData[index].aadhaarNumber = aadharNumber ?? documentNumber;
          } else {
            existingData.push({
              loanApplicationId,
              aadhaarNumber: aadharNumber ?? documentNumber,
              vendorName: aadharIntegrationName,
              timeStamp: new Date().toISOString(),
            });
          }
          sessionStorage.setItem(storageKey, JSON.stringify(existingData));
          setAadhaarPollingLoading(true);
          let retryCount = 0;
          const maxRetry = 6;   
          setAadhaarPollingLoading(true);
          intervalId = setInterval(async () => {
            retryCount++;
            const isLastAttempt = retryCount >= maxRetry;
            let success = false;
              success = await checkAadharDetails(isLastAttempt, false, aadharIntegrationName);
            if (success || isLastAttempt) {
              clearInterval(intervalId);
              setAadhaarPollingLoading(false);
              setLoanStatus(false);
              if (!success && isLastAttempt) {
                toastUpdate("Error", "Aadhaar verification timeout try again", true);
                setLoanStatus(true);
              }
            }
          }, 60000);
        }else if(result?.data?.transactionId && result?.data?.otp){
         setAadharOtpModal(true);
         setTsTransID(result?.data?.transactionId);
           setAadharIntegrationVerified(false);
        }else if (result?.data?.url && result?.data?.transactionId) {
           setAadharIntegrationVerified(false);
          const { transactionId, url } = result.data;
          const numberToSave = aadharNumber ?? documentNumber;
          dispatch(
            saveAadharTransaction({
              transactionId,
              loanApplicationId,
              loanApplicationNumber,
              aadharNumber: numberToSave,
              isAadharAvailable,
            })
          );
          setTsTransID(transactionId);
          window.location.href = url;
        } else {
          setAadharIntegrationVerified(false);
          if(result?.data?.adhaarNumber === "" || result?.data?.adhaarNumber === null || typeof result?.data?.adhaarNumber === "undefined"){
          toastUpdate("Error", "Aadhar details not found, please try again", true);
          setAadharValidationAttempted({ error: true });
          return false;
        }
          const rawDob = result?.data?.dob;
          const parsedDob = parseDob(rawDob);
          setShowAadharCaptureModal(false);
          setAadharValidationAttempted({success:true});
          setDocumentDisable(true);
          const pincodeTrim = result?.data?.pincode?.trim();
          const isPincode = isValidPincode(pincodeTrim);
          const postOffice = result?.data?.postOffice?.trim();
          const isPostOffice = isValidateOnlyAlphabets(postOffice, enabledAddressDetailsValidate);
          const villageTownCity = result?.data?.villageTownCity?.trim();
          const isVillageTownCity = isValidateOnlyAlphabets(villageTownCity, enabledAddressDetailsValidate);
          const district = result?.data?.district?.trim();
          const isDistrict = isValidateOnlyAlphabets(district, enabledAddressDetailsValidate);
           setAddressDetailsAvailable((prev) => ({
          ...prev,
        
          ...(result?.data?.fatherName?.trim() && {
            fatherNameState: true,
          }),
        
          ...(result?.data?.houseNumber?.trim() && {
            houseState: true,
          }),
        
          ...(result?.data?.street?.trim() && {
            streetState: true,
          }),
        
          ...(result?.data?.locality?.trim() && {
            localityState: true,
          }),
        
          ...(postOffice && {
            postOfficeState: isPostOffice,
          }),
        
          ...(villageTownCity && {
            villageState: isVillageTownCity,
          }),
        
          ...(result?.data?.state?.trim() && {
            state: true,
          }),
        
          ...(district && {
            districtState: isDistrict,
          }),
        
          ...(pincodeTrim && {
            pincodeState: isPincode,
          }),
          
          ...(result?.data?.gender?.trim() && {
            genderState: true,
          }),

          ...(parsedDob && {
            dob: true,
          }),
        }));
            if(result?.data?.adhaarNumber){
              if(result?.data?.adhaarNumber.length === 12 && aadharIntegrationName !== aadharVendor?.smcAuthBridgeOCR){
                setAadharNumber(result?.data?.adhaarNumber?.replace(/\s+/g, '')?.slice(0, 12))
              }else{
                setAadharNumber(documentNumber || aadharNumber)
              }
              setAadharNumberState(false);
            }
            if (isDistrict) {
              setDistrict(textFormat(result?.data?.district));
              setDistrictState(false);
            }
            if (result?.data?.dob) {
              if (parsedDob) {
                setDateOfBirth(parsedDob);
                setDateOfBirthState(false);
              }
            }
            if (result?.data?.fatherName) {
              setAadharFatherName(textFormat(result?.data?.fatherName));
              setAadharFatherNameState(false);
            }
            setAadharIntegrationName(ocrVendor);
            if (result?.data?.houseNumber) {
              setHouseNumber(result?.data?.houseNumber);
              setHouseNumberState(false);
            }
            if (result?.data?.locality) {
              setLocality(result?.data?.locality);
              setLocalityState(false);
            }
            if (result?.data?.name) {
              setAadharApplicantName(textFormat(result?.data?.name));
              setAadharApplicantNameState(false);
            }
            if (isPostOffice) {
              setPostOffice(result?.data?.postOffice);
              setPostOfficeState(false);
            }
            if (result?.data?.street) {
              setStreet(result?.data?.street);
              setStreetState(false);
            }
            if (isVillageTownCity) {
              setVillageTownCity(textFormat(result?.data?.villageTownCity));
              setVillageTownCityState(false);
            }
            if (result?.data?.state) {
              setStateName(result?.data?.state);
              // setStateNameState(false);
            }
            if (isPincode) {
              setPincode(result?.data?.pincode);
              setPincodeState(false);
            }
            if (result?.data?.gender) {
             setGenderDetails(capitalizeFirstLetter(result?.data?.gender));
            }
            if (result?.data?.name && result?.data?.name !== "") {
              setIsAadharAvailable(true);
              setAadharVerified(true);
            } else {
              setIsAadharAvailable(false);
              setAadharVerified(false);
            }
        }
      }
    };


  const handleSwitchChange = async () => {
    dispatch(saveAadharDetails(""));
    dispatch(saveLoanApplicantDetails(''))
    setAadharApplicantName("");
        setDateOfBirth("");
        setMotherName("");
        setMateritalStatus("");
        setAnnualIncome("0");
        setMemberCount("");
        setSpouseName("");
        setAadharFatherName("");
        setHouseNumber("");
        setStreet("");
        setLocality("");
        setPostOffice("");
        setVillageTownCity("");
        setStateName("");
        setDistrict("");
        setPincode("");
        setEmail("");
        setDocumentDisable(false)
    await setDocumentName("");
    await setDocumentNumber("");
    await setAadharNumber("");
    await setAadharVerified(false);
    await setIsAadharAvailable(!isAadharAvailable);
  };
  const handlenext = () => {
    setNext();
  };
  const back = () => {
    setBack();
  };
  const setyear = (year) => {
    var date = new Date();

    date.setFullYear(date.getFullYear() - year);

    return date; //# => Thu Mar 31 2011 11:14:50 GMT+0200 (CEST)
  };
  const emaildataVerify=(e)=>{
    setEmail(e);
    if(e !== ""){
      setEmailVerify("error");
    }
    else {
      setEmailVerify("success");
    }
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMobileNumber(e);
    }
  };
  const setAnnualIcomeBlur = (e)=>{
    if(Number(e) < Number(annualIncomeAmount))
 toastUpdate("Error", `Annual Income should be equal or more than ${annualIncomeAmount}`, true)
  }

  const updateApplicantName = (e)=>{
      setAadharApplicantName(e)
    }
    const handleChange1 = (e) => {
      const regex = /^[0-9\b]+$/;
      if (e === "" || regex.test(e)) {
        setPincode(e);
      }
    };
    const handleChange3 = (e) => {
      const regex = /^[0-9\b]+$/;
      if (e === "" || regex.test(e)) {
        setMemberCount(e);
      }
    };
    const handleChange4 = (e) => {
      const regex = /^[0-9\b]+$/;
      if (e === "" || regex.test(e)) {
        setAnnualIncome(e);
      }
    };
    const checkedDueDigilance =(e)=>{
      setDigilance(e.target.checked)
      if(e.target.checked === false){
        setDigilanceState("")
      }
    }
    const handleCorspinCode = (e) => {
      const regex = /^[0-9\b]+$/;
      if (e === "" || regex.test(e)) {
        setCoresPinCode(e);
      }
    };
    const gstStateName = stateList?.filter((item)=> item?.code === gst);
    const handlePreFixName = (e) => {
      setPreFixName(e);
      const gender = prefixToGenderMap[e] || "Other";
      setGender(gender);
    };
    const handleGenderChange = (e) => {
      setGender(e);
      const prefix = genderToPrefixMap[e] || "";
      setPreFixName(prefix);
    };
    const closeAadharCaptureModal = () => {
      setShowAadharCaptureModal(false);
    };
    const handleAadharInegration = async (e) => {
          setAadharIntegrationName(e);
          dispatch(saveAadharDetails(""));
          dispatch(saveLoanApplicantDetails(''))
          setAadharApplicantName("");
          setDateOfBirth("");
          setAadharFatherName("");
          setHouseNumber("");
          setStreet("");
          setLocality("");
          setPostOffice("");
          setVillageTownCity("");
          setStateName("");
          setDistrict("");
          setPincode("");
          setEmail("");
          setDocumentDisable(false)
          setMotherName("");
          setMateritalStatus("");
          setAnnualIncome("0");
          setMemberCount("");
          setSpouseName("");
          if(e === 'MANUAL'){
            setIsAadharAvailable(false);
          }else{
            setIsAadharAvailable(true);
          }
        }
        const handleDocumentName = async (e) => {
          setDocumentName(e);
          setIsAadharAvailable(false);
        }
        const getAddressDisabled = (fieldState) => {
      return (
        !editable ||
        (
          !enabledReKycForDocumentVerification &&
          (
            (isAadharAvailable && fieldState)
            || disabledFields
            || loanStatus
          )
        )
      );
    };
     const closeConfirmationModal = () => {
       setConfirmationModal(false);
       setConfirmationModalHeader("");
       setConfirmationModalMsg("");
     };
     
     const handleNegativeResponse = () => {
       closeConfirmationModal();
       setRiskPresent(true);
     };
     
     const handlePositiveResponse = () => {
       closeConfirmationModal();
       setRiskPresent(false);
     };
    const proceedApplication = () => {
      setConfirmationModalHeader("Risk Warning");
      setConfirmationModalMsg(
        "Customer is in negative list, Do you want to proceed"
      );
      setConfirmationModal(true);
    };
    const checkAadharDetails = async (showError = false, storage = false, integrationName = '') => {
      const storedData =
          JSON?.parse(sessionStorage?.getItem("loanApplicationData")) || [];
        const matchedLoan = storedData?.find(
          item => item?.loanApplicationId === loanApplicationId
        );
        const is15MinutesDone = matchedLoan?.timeStamp
      ? Date.now() - new Date(matchedLoan.timeStamp).getTime() >= 15 * 60 * 1000
      : true;
              const result = await apiHandler({
                url: endpoint.GET_AADHAR_DETAILS + loanApplicationId,
                method: "GET",
                authToken: authToken,
              });
      const status = result?.data?.status?.trim()?.toUpperCase();
              if(result?.data?.error_code){
                if (showError) {
                  toastUpdate("Error", result?.data?.user_description, true);
                   if(!is15MinutesDone){
                    setIsCustomerInit(true);
                  }else{
                    setIsCustomerInit(false);
                  }
                }
                return false;
              }else if (status === statusList.initiated) {
                      setAadharNumber(matchedLoan?.aadhaarNumber);
                      setAadharIntegrationName(integrationName);
                      setIsAadharAvailable(true);
                      toastUpdate("Information", "eKYC is in the initiated stage. Please wait for it to complete.", true);
                      if(!is15MinutesDone){
                        setIsCustomerInit(true);
                      }else{
                        setIsCustomerInit(false);
                      }
                      return false;
                    }else if (status?.toUpperCase() === statusList.failure || status?.toUpperCase() === statusList.failed)  {
                      toastUpdate("Error", "eKYC failed. Please try again.", true);
                      setIsCustomerInit(false);
                      return false;
                    }else{
                      setIsCustomerInit(false);
                let aadhaarToCompare = aadharNumber;
                if (storage) {
                  aadhaarToCompare = matchedLoan?.aadhaarNumber || "";
                  setAadharNumber(matchedLoan?.aadhaarNumber?.replace(/\s+/g, '')?.slice(0, 12))
                }
                const isMatched =
                  result?.data?.adhaarNumber?.slice(-4) || result?.data?.maskedAdhaarNumber?.slice(-4) === aadhaarToCompare?.slice(-4);
                if (!isMatched) {
                  toastUpdate("Error", "Aadhar Number is not matched", true);
                  return true;
                  }
                setShowAadharCaptureModal(false);
                setAadharValidationAttempted({ success: true });
                setDocumentDisable(true);
                const documentLinks =
                  integrationName === aadharVendor?.smcEKYC
                    ? [result?.data?.photoContent?.trim()].filter(Boolean)
                    : [
                        result?.data?.adhaarDocumentLink?.trim(),
                        result?.data?.panDocumentLink?.trim(),
                      ].filter(Boolean);
                  setCallInProgress(true);
                  const res = await apiHandler({
                    url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
                    method: "POST",
                    authToken: authToken,
                    data: {
                      loanApplicationId: loanApplicationId,
                    
                      ...(integrationName === aadharVendor?.smcEKYC
                        ? {
                            kycDocumentLink: result?.data?.photoContent?.trim(),
                          }
                        : {
                            documentPhotoLinks: documentLinks,
                          }),
                    },
                  });
                setCallInProgress(false);
                const rawDob = result?.data?.dob;
                const parsedDob = parseDob(rawDob);
                const postOffice = result?.data?.postOffice?.trim();
                const isPostOffice = isValidateOnlyAlphabets(postOffice, enabledAddressDetailsValidate);
                const villageTownCity = result?.data?.villageTownCity?.trim();
                const isVillageTownCity = isValidateOnlyAlphabets(villageTownCity, enabledAddressDetailsValidate);
                const district = result?.data?.district?.trim();
                const isDistrict = isValidateOnlyAlphabets(district, enabledAddressDetailsValidate);
                 setAddressDetailsAvailable((prev) => ({
                    ...prev,
                  
                    ...(result?.data?.fatherName?.trim() && {
                      fatherNameState: true,
                    }),
                  
                    ...(result?.data?.houseNumber?.trim() && {
                      houseState: true,
                    }),
                  
                    ...(result?.data?.street?.trim() && {
                      streetState: true,
                    }),
                  
                    ...(result?.data?.locality?.trim() && {
                      localityState: true,
                    }),
                  
                    ...(postOffice && {
                      postOfficeState: isPostOffice,
                    }),
                  
                    ...(villageTownCity && {
                      villageState: isVillageTownCity,
                    }),
                  
                    ...(result?.data?.state?.trim() && {
                      state: true,
                    }),
                  
                    ...(district && {
                      districtState: isDistrict,
                    }),
                  
                    ...(result?.data?.pincode?.trim() && {
                      pincodeState: true,
                    }),
                    
                    ...(result?.data?.gender?.trim() && {
                      genderState: true,
                    }),

                    ...(parsedDob && {
                      dob: true,
                    }),
                  }));
                if (result?.data?.adhaarNumber) {
                  // setAadharNumber(result?.data?.adhaarNumber?.replace(/\s+/g, '')?.slice(0, 12))
                  setAadharNumberState(false);
                }
                if (isDistrict) {
                  setDistrict(textFormat(result?.data?.district));
                  setDistrictState(false);
                }
                if (result?.data?.dob) {
                  if (parsedDob) {
                    setDateOfBirth(parsedDob);
                    setDateOfBirthState(false);
                  }
                }
                if(result?.data?.panNumber){
                  setPanNumber(result?.data?.panNumber);
                  
                }
                if (result?.data?.fatherName) {
                  setAadharFatherName(textFormat(result?.data?.fatherName));
                  setAadharFatherNameState(false);
                }
                setAadharIntegrationName(integrationName);
                if (result?.data?.houseNumber) {
                  setHouseNumber(result?.data?.houseNumber);
                  setHouseNumberState(false);
                }
                if (result?.data?.locality) {
                  setLocality(result?.data?.locality);
                  setLocalityState(false);
                }
                if (result?.data?.name) {
                  setAadharApplicantName(textFormat(result?.data?.name));
                  setAadharApplicantNameState(false);
                }
                if (isPostOffice) {
                  setPostOffice(result?.data?.postOffice);
                  setPostOfficeState(false);
                }
                if (result?.data?.street) {
                  setStreet(result?.data?.street);
                  setStreetState(false);
                }
                if (isVillageTownCity) {
                  setVillageTownCity(textFormat(result?.data?.villageTownCity));
                  setVillageTownCityState(false);
                }
                if (result?.data?.state) {
                  setStateName(result?.data?.state);
                  // setStateNameState(false);
                }
                if (result?.data?.pincode) {
                  setPincode(result?.data?.pincode);
                  setPincodeState(false);
                }
                if (result?.data?.gender) {
                  setGenderDetails(capitalizeFirstLetter(result?.data?.gender));
                }
                if (result?.data?.name && result?.data?.name !== "") {
                  setIsAadharAvailable(true);
                  setAadharVerified(true);
                  return true;
                } else {
                  setIsAadharAvailable(false);
                  setAadharVerified(false);
                  return false;
                }
              }
            }
  return (
    <div>
      <Grid container >
         <Grid item xs={12} sm={12} md={12}>
            <SubHeader
              label={headerLabel?.applicantbt}
              subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
             onlyLabel/>
         </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {!disbaledAddharFlag && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <FormControlLabel
                control={
                  <Switch
                    checked={isAadharAvailable}
                    onChange={handleSwitchChange}
                    name="checkedB"
                    color="primary"
                    disabled={!editable || documentDisbale || disabledFields}
                  />
                }
                label="Do you have Aadhar No"
              />
          </Grid>}
          {(isAadharAvailable && !disbaledAddharFlag) ? (
            <>
            {aadharIntegrationListFlag.length > 1 &&
              <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                <CustomeSelectNew
                  label="Aadhar Vendor*"
                  id="aadhr_vendor"
                  value={aadharIntegrationName}
                  setState={setAadharIntegrationName}
                  data={aadharIntegrationListFlag}
                  type="type"
                />
              </Grid>
            }
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Aadhar No"
              required
              error={aadharNumberState}
              value={aadharNumber || ""}
              setState={setAadharNumber} 
              setError={setAadharNumberState}
              id="aadhar_number"
              visiblityIcon={!editable}
              loanAccountNumber={loanAccountNumber}
              viewType={"Aadhar Card"}
              disabled={!editable || documentDisbale || loanStatus}
              setBlur={(e)=> SearchProfileData(e, 'aadharBlur')}
              lastFourDigits={Number(aadharNumber) % 10000}
              validationState={aadharValidationAttempted}
              validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
              />
          </Grid>
          {aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker &&
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
             <CustomeTextField
               label="Applicant Name"
               required
               id="Applicant_name"
               error={panNumber ? nameOnPanCardState:aadharApplicantNameState}
               value={aadharApplicantName || ""}
               setState={updateApplicantName}
               disabled= {disableReverifyFields}
               setError={panNumber ? setNameOnPanCardState : setAadharApplicantNameState}
               />
           </Grid>
          }
          {aadharNumber && aadharNumber.length === 12 && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <Button
                size="small"
                className={classes.nextButton1}
                style={{width:'auto',margin:'0px'}}
                onClick={(event) => SearchProfileData(aadharNumber, functionVariableNamesList?.aadhaar)}
                disabled={applicantDetailAgainstId || isCustomerInit || documentDisbale || (aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker  && !aadharApplicantName)}
              >
                Aadhar Details
              </Button>
            </Grid>
          )}
          {aadharDetails?.adhaarNumber && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
              label="Masked Aadhar No"
              required
              value={aadharDetails?.adhaarNumber || ""}
              disabled = {true}
              id="masked_aadhar_number"
              />
            </Grid>
          )}
          </>
          ):(
            <>
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Document Name*"
              error={documentNameState}
              value={documentName}
              setState={handleDocumentName}
              data={documentNameList}
              setError={setDocumentNameState}
              disabled={isAadharAvailable ? true :!editable || documentDisbale || disabledFields}
              type="displayName"
              id="document_name"
            />
          </Grid>
          {(disbaledAddharFlag && documentName=== documentNamesList?.aadhaar && !hideVendorName ) &&
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Aadhar integration*"
              id="aadhar_integration"
              value={aadharIntegrationName}
              setState={handleAadharInegration}
              data={aadharIntegrationOptions}
              disabled={ !editable || (!enabledReKycForDocumentVerification && (documentDisbale || disabledFields))}
              type="type"
            />
          </Grid>
          }
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Document No"
             required
             error={documentNumberState}
             value={documentNumber || ""}
             setState={setDocumentNumber}
             setError={setDocumentNumberState}
             setBlur={(e)=>SearchProfileData(e,'blur')}
             disabled={!editable || documentDisbale || disabledFields}
             id="document_number"
             visiblityIcon={!editable && documentName === "AADHAR_CARD"}
             loanAccountNumber={loanAccountNumber}
             viewType={documentName}
             lastFourDigits={Number(documentNumber) % 10000}
             validationState={aadharValidationAttempted}
             validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
             />
             </Grid>
             {(disbaledAddharFlag && documentNumber?.length === 12 && aadharIntegrationName !== aadharVendor?.manual && documentName=== documentNamesList?.aadhaar ) &&
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                   <Button
                     size="small"
                     className={classes.nextButton1}
                     style={{width:'auto',margin:'0px'}}
                     onClick={(event) => SearchProfileData(aadharNumber,functionVariableNamesList?.aadhaar)}
                     disabled={!enabledReKycForDocumentVerification && (applicantDetailAgainstId || documentDisbale) || isCustomerInit}
                   >
                     Aadhar Details
                   </Button>
                 </Grid>
              }
             {(documentName === "PASSPORT" || documentName === "DRIVING_LICENSE") && 
             <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
               <InputLabel
                className={classes.label}
                style={{ textAlign: "left"}}
              >
               Document Expiry*
              </InputLabel>
              <CustomeDateCalender
                error={documentExpiryState}
                handleDateChange={handleDocumentExpiry}
                selectedDate={documentExpiry ? documentExpiry : null}
                id="document_expiry"
                inputProps={{
                  disabled: isAadharAvailable ? true : !editable || documentDisbale ,
                }}
              />
         </Grid>
         }
         </>
          )}
            {showPreFixName && <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Applicant Pre Name*"
              id="pre_name"
              value={prefixName || PreFixNameList[0]}
              setState={handlePreFixName}
              data={PreFixNameList}
              disabled={!editable}
              setError={setPreFixNameState}
              error={prefixNameState}
            /> 
          </Grid>}
          {((aadharIntegrationName !== aadharVendor?.smcAuthBridgeDigiLocker && isAadharAvailable) || !isAadharAvailable || disbaledAddharFlag) &&
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Applicant Name"
             required
             error={panNumber ? nameOnPanCardState:aadharApplicantNameState}
             value={aadharApplicantName || ""}
             setState={updateApplicantName}
             disabled= {(((isAadharAvailable ? true : !editable) || disabledFields || loanStatus || (PanNameObj && disabledApplicantLoanDetailsFlag)) && !enabledFieldsForApplciantPage )|| (enabledFieldsForApplciantPage && !editable)}
             setError={panNumber ? setNameOnPanCardState : setAadharApplicantNameState}
             id="applicant_name"
             />
         </Grid>
          }
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Father Name"
             required
             id="father_name"
             error={aadharFatherNameState}
             value={aadharFatherName || ""}
             setState={setAadharFatherName} 
             setError={setAadharFatherNameState}
             disabled= {(isAadharAvailable ? addressDetailsAvailable?.fatherNameState : !editable) || disabledFields || loanStatus}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Mother Name"
             required
             id="mother_name"
             error={motherNameErrorState}
             value={motherName || ""}
             setState={setMotherName} 
             setError={setMotherNameErrorState}
             disabled= {!editable}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <InputLabel
                className={classes.label}
                style={{ textAlign: "left"}}
              >
                Date Of Birth(DD/MM/YYYY)*
              </InputLabel>
              <CustomeDateCalender
                handleDateChange={handleDateChange}
                inputProps={{
                  minDate: setyear(maxAgeForDateOfBirth),
                  maxDate: setyear(minAgeForDateOfBirth),
                  disabled: ((((isAadharAvailable ? addressDetailsAvailable?.dob : !editable) || disabledFields || loanStatus)) && enabledFieldsForApplciantPage) || (enabledFieldsForApplciantPage && !editable),
                }}
                selectedDate={dateOfBirth ? dateOfBirth : null}
                id="date_of_birth"
              />
         </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Marital Status*"
              error={maritalStatusState}
              value={maritalStatus}
              id="document_name"
              setState={setMateritalStatus}
              data={maritalStatusList}
              setError={setmaritalStatusState}
              disabled= {!editable || loanStatus}
              type="name"
            />
          </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Flat No./House No./Plot No./Building Name"
             required
             error={houseNumberState}
             value={houseNumber || ""}
             setState={setHouseNumber} 
             setError={setHouseNumberState}
             disabled={getAddressDisabled(addressDetailsAvailable?.houseState)}
             id="house_number"
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Street"
             required
             error={streetState}
             value={street || ""}
             setState={setStreet} 
             setError={setStreetState}
             disabled={getAddressDisabled(addressDetailsAvailable?.streetState)}
             id="street"
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Locality"
             required
             error={localityState}
             value={locality || ""}
             setState={setLocality} 
             setError={setLocalityState}
             disabled={getAddressDisabled(addressDetailsAvailable?.localityState)}
             id="locality"
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="PostOffice"
             required
             type="alphabets"
             error={postOfficeState}
             value={postOffice || ""}
             setState={setPostOffice}
             setError={setPostOfficeState}
             disabled={getAddressDisabled(addressDetailsAvailable?.postOfficeState)}
             id="post_office"
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Village/Town/City"
             required
             type="alphabets"
             error={villageTownCityState}
             value={villageTownCity || ""}
             setState={setVillageTownCity}
             setError={setVillageTownCityState}
             disabled={getAddressDisabled(addressDetailsAvailable?.villageState)}
             id="village_town"
             />
         </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
         {(isAadharAvailable && stateName) || status !== "INPROCESS" ? (
          <CustomeTextField
          label="State"
          required
          value={stateName ? stateName : ''}
          disabled={getAddressDisabled(addressDetailsAvailable?.state)}
          id="state"
          />
           ):(
            <CustomeSelectNew
            label="State*"
            value={stateName ? stateName : ''}
            setState={setStateName}
            data={stateList}
            type="name"
            disabled={getAddressDisabled(addressDetailsAvailable?.state)}
            id="state"
            />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="District"
             required
             type="alphabets"
             error={districtState}
             value={district || ""}
             setState={setDistrict}
             setError={setDistrictState}
             disabled={getAddressDisabled(addressDetailsAvailable?.districtState)}
             id="district"
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Pincode"
             required
             type="digits"
             error={pincodeState}
             value={pincode || ""}
             setState={handleChange1}
             disabled={getAddressDisabled(addressDetailsAvailable?.pincodeState)}
             setError={setPincodeState}
             maxLength="6"
             id="pincode"
             />
         </Grid>
         {showEmailOnApplicantFlag && 
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}  style={{ position: "relative" }}>
           <CustomeTextField
             label="Email"
            //  required
             error={emailState}
             value={email?.toLowerCase() || ""}
             disabled={(isAadharAvailable ? true : !editable) || disabledFields || loanStatus || emailVerify === "success"}
             setState={emaildataVerify} 
             type='notCapital'
             setError={setEmailState}
             id="email"
             validationState={emailValidationAttempted}
             validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
             />
              { (editable && emailVerify !== "success") && <Button
                disabled={!email || isAadharAvailable ? true : !editable || disabledFields || loanStatus}
                size="small"
                style={{
                  height: "40px",
                  width: "75px",
                  position: "absolute",
                  right: 0,
                  top: 0,
                  margin:0,
                  backgroundColor:brandTheme.button2Color,
                  color:brandTheme.white
                }}
               onClick={() => sendEMailOtp()}  
              >
                Verify
              </Button>}
         </Grid>
            }
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Alternate Mobile Number"
            //  required
             error={mobileNumberState}
             value={mobileNumber || ""}
             setState={handleChange} 
             maxLength="10"
             setError={setMobileNumberState}
             disabled={!editable}
             id="alternate_mobile_number"
             />
         </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Gender*"
              value={gender || GenderList[0]}
              setState={handleGenderChange}
              // type="list"
              data={GenderList}
              disabled={getAddressDisabled(addressDetailsAvailable?.genderState)}
              id="gender"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Name of Spouse"
             required
             id="spouse_name"
             error={spouseNameState}
             value={maritalStatus === "Single" ? "" : spouseName}
             setState={setSpouseName} 
             setError={setSpouseNameState}
             disabled= {maritalStatus === "Single"||!editable}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Number of Member"
             required
             id="number_member"
             error={memeberCountError}
             value={memberCount || ""}
             setState={handleChange3} 
             setError={setMemberCountError}
             maxLength="3"
             disabled= {!editable}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Income"
             required
             id="annual_income"
             error={annualIncomeState}
             value={annualIncome || ""}
             setState={handleChange4} 
             setError={setAnnualIncomeState}
             disabled= {!editable}
             setBlur={setAnnualIcomeBlur}
             />
         </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Occupation Type*"
              value={occupationTypes || OccupationList[0]}
              setState={setoccupationTypes}
              // type="list"
              data={OccupationList}
              disabled={!editable || loanStatus}
              id="occupation_type"
            />
          </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Purpose Of Loan*"
              value={purposeOfLoan || PurposeOfLoan[0]}
              // type="list"
              setState={setPurposeOfLoan}
              data={PurposeOfLoan}
              disabled={!editable || loanStatus}
              id="purpose_of_loan"
            />
          </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
              <CustomeSelectNew
                label="Customer Type*"
                id="customer_type"
                value={customerType || customerTypeData[0]?.code}
                type="name"
                setState={setCustomerType}
                data={customerTypeData}
                disabled={!editable || loanStatus}
              />
            </Grid>        
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
             label="GST Number"
             value={gstNumber  || ""}
             setState={setGstNumber} 
             disabled={!editable || loanStatus}
             type="gst"
             />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          {!editable  ? (
          <CustomeTextField
          label={gstNumber ? "GST State*" : "GST State"}
          required={!!gstNumber}
          id="gst_state"
          value={gstStateName?.length > 0 ? gstStateName?.[0]?.name : ""}
          disabled={!editable}
          />
           ):(
            <CustomeSelectNew
            label={gstNumber ? "GST State*" : "GST State"}
            value={gst ? gst : ""}
            setState={setGst}
            data={stateList}
            type="type"
            id="gst_state"
            disabled={!editable}
            />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr} style={{position:'relative'}}>
          <CustomeTextField
             label="Pan Number"
             id="pan_number"
             value={panNumber?.toUpperCase()  || ""}
             setState={setPanNumber}
             disabled={!editable || panNumberDisabled}
             validationState={panValidationAttempted}
             validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
             />
              {editable === true && (
                           <Button
                             style={{
                               height: "40px",
                               width: "75px",
                               position: "absolute",
                               right: 0,
                               top: 0,
                               margin: 0,
                             }}
                             size="small"
                             disabled={
                                (
                                  !enabledReKycForDocumentVerification &&
                                  (panVerified || panNumberDisabled)
                                ) ||
                                !isValidValue(panNumber) ||
                                !isValidValue(aadharApplicantName) ||
                                !isValidValue(dateOfBirth) ||
                                panNumber?.length < 10
                              }
                             onClick={() => SearchProfileData("", "PAN")}
                             className={classes.nextButton1}
                           >
                             verify
                           </Button>
                         )}
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
             label="Pan Name"
             id="pan_name"
             value={nameOnPanCard  || ""}
             disabled
             />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
                        <input
                          style={{ marginTop: 2, width:'30px', height:'30px' }}
                          type="checkbox"
                          // className={classTable.checkboxInput}
                          // checked={groupDetails[i].packetSealed}
                          value= {digilance}
                          name="Profiling"
                          onChange={(e) => checkedDueDigilance(e)}
                          checked={digilance}
                          disabled={!editable}
                        />
                     Profiling</label>
                      </Grid>
        {     digilance &&          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
        {status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfiestatus  ?<CustomeSelectNew
              label="Profiling*"
              id="Profiling"
              value={digilanceState}
              setState={setDigilanceState}
              error={dueDigilance}
              setError={setDueDigilance}
              type="name"
              data={digilanceData}
              disabled={!editable || loanStatus}
            />: 
            <CustomeTextField
            label="Profiling"
              id="Profiling"
              required
            value={digilanceState}
            disabled
            />
            }
          </Grid>}
          <Grid item xs={12} sm={12} md={12} className={classes.addressContainer}>
         <Grid
        item
        xs={12}
        sm={7}
        md={6}
      >
        <h2 className={classes.header}>Correspondence Address</h2>
      </Grid>
      <Grid
        item
        xs={12}
        sm={5}
        md={6}
        className={classes.inputFieldContainer}
        style={{marginTop:"15px",marginLeft:"0px"}}
      > <label>
      <input
        type="checkbox"
        value={sameAddress}
        onChange={(e) => checkedAddress(e)}
        checked={sameAddress  || loanStatus ? true : false}
        disabled={!editable || loanStatus}
      />
      same as permanent address
    </label></Grid>
          </Grid></Grid></Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
            <CorrespondenceAddress
              sameAddress={sameAddress}
              houseCorrNumberState={houseCorrNumberState}
              disabledFields={disabledFields}
              streetCorrState={streetCorrState}
              localityCorrState={localityCorrState}
              postOfficeCorrState={postOfficeCorrState}
              villageTownCityCorrState={villageTownCityCorrState}
              districtCorrState={districtCorrState}
              pincodeCorrState={pincodeCorrState}
              stateNameCorrState={stateNameCorrState}
              setHouseCorrNumberState={setHouseCorrNumberState}
              setDistrictCorrState={setDistrictCorrState}
              setVillageTownCityCorrState={setVillageTownCityCorrState}
              setStateNameCorrState={setStateNameCorrState}
              setPostOfficeCorrState={setPostOfficeCorrState}
              setLocalityCorrState={setLocalityCorrState}
              setStreetCorrState={setStreetCorrState}
              setPincodeCorrState={setPincodeCorrState}
              houseNumber={houseNumber}
              editable={editable}
              street={street}
              locality={locality}
              postOffice={postOffice}
              villageTownCity={villageTownCity}
              stateName={stateName}
              stateList={stateList}
              district={district}
              pincode={pincode}
              classes={classes}
              coresHouseNumber={coresHouseNumber}
              setCoresHouseNumber={setCoresHouseNumber}
              coresLocality={coresLocality}
              setCoresLocality={setCoresLocality}
              coresStreet={coresStreet}
              setCoresStreet={setCoresStreet}
              coresPostOffice={coresPostOffice}
              setCoresPostOffice={setCoresPostOffice}
              coresVillage={coresVillage}
              setCoresVillage={setCoresVillage}
              coresDistrict={coresDistrict}
              setCoresDistrict={setCoresDistrict}
              coresPinCode={coresPinCode}
              setCoresPinCode={handleCorspinCode}
              coresState={coresState}
              setCoresState={setCoresState}
              loanStatus={loanStatus}
            />

          {status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie? (
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{
                  textAlign: window.innerWidth < 360 ? "center" : "right",
                  marginTop:"5%"
                }}
              >
                {/* <Button
                  // style={{ margin: "5px" }}
                  size="small"
                  className={classes.nextButton1}
                  // className="bg-gradient-theme-left border-0"
                  onClick={() => handlecancelapplicant()}
                >
                  Back
                </Button> */}

                <Button
                  className={classes.nextButton}
                  size="small"
                  // color="info"
                  disabled={callInProgress || loanStatus || riskPresent}
                  onClick={(event) => handlecreateapplicantSubmit(event)}
                >
                  Next
                </Button>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{
                  textAlign: window.innerWidth < 360 ? "center" : "right",
                  marginTop:"5%"
                }}
              >
                <Button
                  size="small"
                  className={classes.nextButton1}
                  disabled={callInProgress}
                  onClick={() => back()}
                >
                  Back
                </Button>
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress || loanStatus}
                  onClick={() => handlenext()}
                >
                  Next
                </Button>
              </GridItem>
            </GridContainer>
          )}
        </GridItem>
     
   {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
            setShowModal={setShowModal}
            modalrepOpen={modalrepOpen}
            setModalReOpen={setModalReOpen}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        {aadhaarPollingLoading && (
          <CircularProgresss callInProgress={aadhaarPollingLoading} text="Customer authentication is in process"/>
        )}
        {showModal && (
          <OtpModal
            handleClose={handleClose}
            showModal={showModal}
            Otp={verifyOtp}
            ResendOtp={sendEMailOtp} 
          />
        )}
        {aadharOtpModal && (
          <OtpModal
            handleClose={handleAadharModalClose}
            showModal={aadharOtpModal}
            Otp={verifyAadharOtp}
            noResendOtp
          />
        )}
        {showAadharCaptureModal && (
          <AadharPhotoCaptureModal
            showModal={showAadharCaptureModal}
            closeModal={closeAadharCaptureModal}
            classesChild={classes}
            loanApplicationId={loanApplicationId}
            editable={editable}
            handleSave = {handleAadharCaptureData}
            singlePhtotAdhaarOcr={singlePhtotAdhaarOcr}
            featureFlags={featureFlags}
          />
        )}
        {confirmationModal && (
            <ConfirmationModal
              confirmationModal={confirmationModal}
              confirmationModalHeader={confirmationModalHeader}
              confirmationModalMsg={confirmationModalMsg}
              handleNegativeButton={handleNegativeResponse}
              handlePositiveButton={handlePositiveResponse}
              classes={classes}
            />
          )}
      </GridContainer>

    </div>
  );
};

ApplicantBT.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default withStyles(styles)(ApplicantBT);